import { hasHtml, sanitizeHtml } from "../lib/richtext";
import { useLang } from "../i18n/LanguageContext";

// Affiche un texte traduit : HTML épuré s'il est mis en forme (gras, couleurs…),
// texte simple sinon. `path` (ex. « faq.items.0.q ») rend le texte cliquable en
// mode « page Word » (admin) — y compris pour les listes (FAQ, étapes, sections).
export default function RichText({ text, className = "", path = "" }) {
  const { editMode } = useLang();
  const inner = !hasHtml(text)
    ? <span className={className}>{text}</span>
    : <span className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }} />;
  if (path && editMode) return <span data-edit-path={path} className="mt-ed">{inner}</span>;
  return inner;
}
